import { calculateTotalWeightForSupplies } from "../utils/calculateHelpers";

export default function calculate(props) {
  return calculateTotalWeightForSupplies(props);
}
